export default "__VITE_ASSET__nLXut2GX__"